import { createSelector } from 'reselect';

import { getCertificateStats } from 'common.components/certificate-modal/selectors';

import { TEACHER_CERTIFICATE_SLUG } from '../../constants/certificates';
import { ReduxTeacherStore } from '../../typings';

import { TeacherCertificateModalReduxStore, TeacherCertificateModalStore } from './typings';

const storeSelector = (storeState: TeacherCertificateModalReduxStore): TeacherCertificateModalStore =>
    storeState.teacherCertificateModal;

export const getIsModalOpened = createSelector(storeSelector, (store) => store.isModalOpened);

export const getTeacherCertificateStats = (storeState: ReduxTeacherStore) =>
    getCertificateStats(storeState, { slug: TEACHER_CERTIFICATE_SLUG });
